import type { ElementStyle, ToolConfig } from '@/types';

// Canvas defaults
export const DEFAULT_CANVAS_SIZE = {
  width: 1200,
  height: 800,
} as const;

export const VIEWPORT_BOUNDS = {
  minZoom: 0.1,
  maxZoom: 5.0,
  defaultZoom: 1.0,
} as const;

// Element defaults
export const DEFAULT_ELEMENT_STYLE: ElementStyle = {
  strokeColor: '#ffffff',
  strokeWidth: 2,
  strokeStyle: 'solid',
  fillColor: 'transparent',
  fillPattern: 'solid',
  opacity: 1,
  fontSize: 16,
  fontFamily: 'Arial',
  textAlign: 'center',
  textVerticalAlign: 'middle',
  textType: 'sloppy',
} as const;

export const ELEMENT_CONSTRAINTS = {
  minWidth: 10,
  minHeight: 10,
  maxWidth: 5000,
  maxHeight: 5000,
} as const;

// Tool configurations
export const TOOL_CONFIGS: Record<string, ToolConfig> = {
  select: {
    name: 'Select',
    icon: 'cursor',
    shortcut: 'V',
    cursor: 'default',
  },
  rectangle: {
    name: 'Rectangle',
    icon: 'rectangle',
    shortcut: 'R',
    cursor: 'crosshair',
  },
  ellipse: {
    name: 'Ellipse',
    icon: 'ellipse',
    shortcut: 'E',
    cursor: 'crosshair',
  },
  line: {
    name: 'Line',
    icon: 'line',
    shortcut: 'L',
    cursor: 'crosshair',
  },
  text: {
    name: 'Text',
    icon: 'text',
    shortcut: 'T',
    cursor: 'text',
  },
} as const;

// UI constants
export const UI_CONSTANTS = {
  toolboxWidth: 60,
  contextMenuWidth: 220,
  selectionHandleSize: 8,
  hitTestTolerance: 5,
} as const;

// Keyboard shortcuts
export const KEYBOARD_SHORTCUTS = {
  UNDO: 'ctrl+z',
  REDO: 'ctrl+shift+z',
  DELETE: 'Delete',
  ESCAPE: 'Escape',
  SPACE: ' ',
} as const;

// Colors
export const COLORS = {
  selection: '#007acc',
  grid: '#e0e0e0',
  background: '#ffffff',
  ui: {
    primary: '#007acc',
    secondary: '#666666',
    accent: '#ff6b35',
    border: '#d1d5db',
  },
} as const;

// Utility functions
export const generateId = (): string => {
  return `element_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};
